import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

export const useSurveyData = (
  userId: string,
  survey_type?: string,
  limit?: number
) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchSurvey = async (params: { survey_type?: string; limit?: number } = {}) => {
    const { survey_type, limit } = params;
    const queryStr = qs.stringify({
      survey_type,
      limit,
    })

    const requestObj = {
      route: `/private/survey/${queryStr ? `?${queryStr}` : ''}`,
      token: userToken,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Coach-Override': userId,
      },
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<any[], Error>(
    ['survey-data', userToken, userId, survey_type, limit],
    () => fetchSurvey({ survey_type, limit }),
    {
      enabled: isAuthenticated && !loading && !!userToken,
      refetchOnWindowFocus: false,
    }
  );

  return { surveys: data, isLoading, isError };
};
